export const version = "signing-key/5.4.0";
//# sourceMappingURL=_version.js.map